import { useMemo, useState } from "react";
import { toast } from "sonner";
import { Plus, Search, UtensilsCrossed } from "lucide-react";
import { addItemsToTab, formatMXN } from "@/lib/api";

/** ONE PAY (no AI): add dishes/products to an open tab by tapping — no voice. */
export const ManualTabPanel = ({ tabs, products, onChanged, onOpenManual }) => {
  const [tabId, setTabId] = useState("");
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(null);

  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    const base = (products || []).filter((p) => Number(p.sale_price) > 0);
    return (s ? base.filter((p) => (p.name || "").toLowerCase().includes(s)) : base).slice(0, 24);
  }, [products, q]);

  const current = tabs.find((t) => t.id === (tabId || tabs[0]?.id));

  const add = async (p) => {
    if (!current) return toast.error("Primero abre una cuenta (mesa o cliente)");
    setBusy(p.id);
    try {
      await addItemsToTab(current.id, [{ product_id: p.id, name: p.name, qty: 1, unit_price: Number(p.sale_price) }]);
      toast.success(`+ ${p.name} → ${current.customer_name}`);
      onChanged?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "No se pudo agregar"); }
    finally { setBusy(null); }
  };

  return (
    <div className="sticky top-24 rounded-3xl border border-white/10 bg-gradient-to-br from-white/[0.03] to-white/[0.01] p-6" data-testid="mesas-manual-panel">
      <p className="font-mono text-[10px] tracking-widest text-white/40 uppercase flex items-center gap-2 mb-3"><UtensilsCrossed size={12} className="text-[#CCFF00]" /> Agregar a una cuenta</p>
      {tabs.length === 0 ? (
        <button onClick={onOpenManual} className="w-full rounded-2xl border border-dashed border-white/15 p-5 text-sm text-white/60 hover:text-white hover:border-white/40" data-testid="mesas-manual-open">
          <Plus size={14} className="inline mr-1" /> Abrir la primera cuenta
        </button>
      ) : (
        <select value={current?.id || ""} onChange={(e) => setTabId(e.target.value)} className="w-full bg-black/60 border border-white/10 rounded-xl px-3 py-2 text-sm mb-3" data-testid="mesas-manual-tab-select">
          {tabs.map((t) => <option key={t.id} value={t.id}>{t.customer_name} · {formatMXN(t.total)}</option>)}
        </select>
      )}
      <div className="flex items-center gap-2 bg-black/60 border border-white/10 rounded-xl px-3 py-2 mb-3">
        <Search size={13} className="text-white/40" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar platillo o producto…" className="flex-1 bg-transparent outline-none text-sm placeholder-white/30" data-testid="mesas-manual-search" />
      </div>
      <div className="grid grid-cols-2 gap-2 max-h-[46vh] overflow-y-auto pr-1" data-testid="mesas-manual-products">
        {list.length === 0 ? <p className="col-span-2 text-xs text-white/40 p-2">Sin productos con precio. Agrégalos en el Menú de platillos o en Inventario.</p>
          : list.map((p) => (
            <button key={p.id} onClick={() => add(p)} disabled={busy === p.id} className="text-left rounded-xl border border-white/10 bg-black/40 hover:border-[#CCFF00]/50 px-3 py-2 disabled:opacity-50" data-testid={`mesas-manual-add-${p.id}`}>
              <p className="text-sm truncate">{p.name}</p>
              <p className="font-mono text-[10px] text-[#CCFF00]">{formatMXN(p.sale_price)}</p>
            </button>
          ))}
      </div>
      <p className="mt-3 text-[10px] font-mono uppercase tracking-widest text-white/30">Plan ONE PAY · sin comandos de voz</p>
    </div>
  );
};
